/**
 * Configuration constants for the Pill component.
 *
 * This file contains reusable class definitions for the Pill component, including:
 * - `pillBaseClasses`: Base styles applied to all Pills for consistent alignment and font.
 * - `pillVariants`: Predefined background color variants for different statuses or categories.
 * - `pillSizes`: Size configurations (default, small, large) with responsive padding and dimensions.
 * - `pillTextClasses`: Text-specific classes for handling truncation and overflow.
 */
export const pillBaseClasses = `
  inline-flex items-center justify-center rounded-[5px]
  font-roboto font-medium text-black
`;

export const pillVariants = {
  default: 'bg-[#E9E9E8]',
  purple: 'bg-[#F7EEFF]',
  yellow: 'bg-[#FFFCCC]',
  green: 'bg-[#E8FFE4]',
  red: 'bg-[#FFE8EA]',
  blue: 'bg-[#E1F6FF]',
  orange: 'bg-[#FFECDB]',
  brown: 'bg-[#E1CFCF]',
  gray: 'bg-[#F2F6FA]',
  lightBlue: 'bg-[#E1F6FF]',
  darkLightBlue: 'bg-[#E1E9FF]',
  darkPurple: 'bg-[#EDD8FF]',
};

export const pillSizes = {
  default: 'w-[150px] h-[32px] py-[8px] px-[10px] text-sm',
  small: 'w-[100px] h-[28px] py-[6px] px-[8px] text-xs',
  large: 'w-[160px] h-[40px] py-[10px] px-[12px] text-base',
};

export const pillTextClasses = `
  truncate text-ellipsis overflow-hidden whitespace-nowrap
`;

export const eventsPills = {
  mopping_event: 'darkPurple',
  transit_event: 'red',
  water_change_event: 'orange',
  water_fill_event: 'lightBlue',
  non_event: 'default',
  default: 'default',
  location_change_event: 'green',
  departure_event: 'yellow',
  no_activity_event: 'blue',
  no_activity_session: 'blue',
  mopping_session_event: 'purple',
  wringer_attachment: 'yellow',
  wringer_removal: 'brown',
  water_fill: 'darkLightBlue',
};

export const waterEventsPills = {
  transit: 'red',
  'wringer removal': 'brown',
  'wringer attachment': 'purple',
  'water added': 'blue',
  default: 'default',
  'water fill': 'lightBlue',
};
